// extracted by mini-css-extract-plugin
export default {"categoryContainer":"CategoryContainer_categoryContainer__hverM","cardsContainer":"CategoryContainer_cardsContainer__hF7Ak"};